var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import { GrowthInventoryWidgetComponent } from '../../components/growth-inventory-widget/GrowthInventoryWidget';
export var withGrowthInventory = Component => {
  var Wrapper = props => {
    var _props$withGrowthInve = props.withGrowthInventory,
      withGrowthInventory = _props$withGrowthInve === void 0 ? false : _props$withGrowthInve,
      _props$withGrowthInve2 = props.withGrowthInventoryProps,
      withGrowthInventoryProps = _props$withGrowthInve2 === void 0 ? {} : _props$withGrowthInve2,
      onUserAction = props.onUserAction,
      restProps = __rest(props, ["withGrowthInventory", "withGrowthInventoryProps", "onUserAction"]);
    return _jsx(_Fragment, {
      children: withGrowthInventory ? _jsx(GrowthInventoryWidgetComponent, Object.assign({}, withGrowthInventoryProps, getTestId(props.testID, 'withGrowthInventory'), {
        onUserAction: onUserAction
      })) : _jsx(Component, Object.assign({}, restProps, {
        onUserAction: onUserAction
      }))
    });
  };
  return Wrapper;
};